import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class CalidadModule {
  id: number;
  lote: string;
  id_producto: string;
  producto: string;
  usuario: string;
  foto: string;
  documentno: string;
  qtyentered: string;
  observacion: string;

}
